import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "./leafletIcons";

interface MapPickerProps {
  lat: number | null;
  lng: number | null;
  onChange?: (lat: number, lng: number) => void;
}

function MapController({ lat, lng }: { lat: number | null; lng: number | null }) {
  const map = useMap();
  useEffect(() => {
    if (lat !== null && lng !== null) {
      map.setView([lat, lng], 13);
    }
  }, [lat, lng, map]);
  return null;
}

function ClickHandler({ onChange }: { onChange?: (lat: number, lng: number) => void }) {
  useMapEvents({
    click(e) {
      onChange?.(e.latlng.lat, e.latlng.lng);
    },
  });
  return null;
}

export default function MapPicker({ lat, lng, onChange }: MapPickerProps) {
  const hasPin = lat !== null && lng !== null;
  const center: [number, number] = hasPin ? [lat!, lng!] : [45, -93];
  const zoom = hasPin ? 13 : 4;

  return (
    <MapContainer
      center={center}
      zoom={zoom}
      style={{ height: 300, width: "100%", borderRadius: 6, border: "1px solid #d1d5db" }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <MapController lat={lat} lng={lng} />
      <ClickHandler onChange={onChange} />
      {hasPin && <Marker position={[lat!, lng!]} />}
    </MapContainer>
  );
}
